export function bindMessageInputSizing(textarea: HTMLTextAreaElement): void {
  const resize = (): void => {
    textarea.style.height = 'auto';
    const maxHeight = Number.parseFloat(getComputedStyle(textarea).maxHeight);
    const nextHeight = Number.isFinite(maxHeight)
      ? Math.min(textarea.scrollHeight, maxHeight)
      : textarea.scrollHeight;
    textarea.style.height = `${nextHeight}px`;
  };

  textarea.addEventListener('input', resize);
  resize();
}
